<span #focusReset tabindex="0"></span>
<app-skip-to-menu></app-skip-to-menu>

<div
  #appRef
  class="app"
  [ngClass]="classNameList"
  [attr.data-zero-results]="!!((isZeroResult$ | async) && !(hasFilters$ | async))"
  [attr.data-hj-suppress]="!isHotjarAllowedRoute ? 'suppress' : null"
>
  <app-mobile-sidenav *ngIf="showMobileNavigation" [routeChangeEmission]="routeChangeEmission"></app-mobile-sidenav>

  <app-generic-buyer-header
    *ngIf="isHeaderSimplified !== undefined && !isHeaderSimplified; else simpleHeader"
    [isUserBlocked]="isUserBlocked$ | async"
  >
  </app-generic-buyer-header>

  <app-generic-navigation
    *ngIf="!((isUserBlocked$ | async) || showMobileNavigation || isCheckoutPage) && !isEmployeeRestrictedView"
    class="app__top-categories-navbar"
    [ngClass]="{ 'subsidiary-account': (userInfo$ | async)?.isSubsidiary }"
  >
  </app-generic-navigation>

  <mm-alert-wrapper class="app__alert-wrapper"></mm-alert-wrapper>

  <div *ngIf="isMobileOrTablet && !(isLoggedIn$ | async) && !isPriceTypeExplanationCookieExist && !isStoryblokPreview">
    <app-mobile-explanation-message></app-mobile-explanation-message>
  </div>
  <ng-container *ngIf="isPLP && userInfo$ | async as userInfo">
    <app-subsidiary-alert
      class="subsidiary__account-alert"
      [ngClass]="{ mobileOrTablet: isMobileOrTablet }"
      [organizationName]="userInfo?.organizationName"
      [isSubsidiaryAccount]="isSubsidiaryAccount$ | async"
      [isMobileOrTablet]="isMobileOrTablet"
    >
    </app-subsidiary-alert>
  </ng-container>

  <main
    class="app__content-container"
    [ngClass]="{
      'app__content-container__metrox': isMetroxRoutes,
      transparentBg: (isNewPLPVariantRestyle$ | async) && isPLP,
      'app__content-container__metrox__box': isPdP
    }"
    id="main-page-content"
  >
    <router-outlet></router-outlet>
  </main>
  <app-generic-footer
    appIsVisible
    (isVisible)="onIsVisible()"
    [loadFooter]="loadFooter | async"
    *ngIf="!isFooterSimplified; else simpleFooter"
  >
  </app-generic-footer>

  <cms-cookie-disclaimer #cookieConsentRef></cms-cookie-disclaimer>
</div>

<ng-template #simpleHeader>
  <app-generic-header-simplified></app-generic-header-simplified>
</ng-template>

<ng-template #simpleFooter>
  <app-generic-footer-simplified></app-generic-footer-simplified>
</ng-template>
